import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTranslocoLocale, TranslocoLocaleModule } from '@jsverse/transloco-locale';

@NgModule({
	exports: [TranslocoModule, TranslocoLocaleModule],
	providers: [
		provideTranslocoLocale({
			langToLocaleMapping: {
				en: 'en-US',
				de: 'de-DE',
			},
		}),
		provideTransloco({
			config: {
				availableLangs: ['en', 'de'],
				defaultLang: 'de',
				// Remove this option if your application doesn't support changing language in runtime.
				reRenderOnLangChange: true,
				fallbackLang: 'de',
				prodMode: true,
			},
			loader: TranslocoHttpLoader,
		}),
	],
})
export class TranslocoRootModule {}
